'use strict';

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

require('babel-polyfill');

require('helpers/ie11-classlist-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dal = require('@classpass/dal');

var _dal2 = _interopRequireDefault(_dal);

var _ajaxClient = require('@classpass/dal/ajax-client');

var _ajaxClient2 = _interopRequireDefault(_ajaxClient);

var _publicEndpoints = require('@classpass/dal/public-endpoints');

var _publicEndpoints2 = _interopRequireDefault(_publicEndpoints);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _create = require('redux/create');

var _create2 = _interopRequireDefault(_create);

var _store = require('store');

var _ClientProvider = require('providers/ClientProvider');

var _supportedLocales = require('locales/supported-locales.json');

var _supportedLocales2 = _interopRequireDefault(_supportedLocales);

var _locale = require('redux/modules/locale');

var _request = require('redux/modules/request');

var _statsd = require('helpers/statsd');

var _multitrack = require('helpers/multitrack');

var _isMobile = require('helpers/isMobile');

var _routes = require('routes');

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/first */

/**
 * Entry point for the React app on the client side
 */

if (window.resourceBaseUrl) {
  __webpack_public_path__ = window.resourceBaseUrl + '/dist/'; // eslint-disable-line
}

var transport = new _ajaxClient2.default({
  token: (0, _universalConfig2.default)().unauthenticatedToken
}, window.location.protocol + '//' + window.location.host + '/_api');

transport.on('request', function (event) {
  return (0, _statsd.trackApiRequest)(false, event);
});
transport.on('success', function (event) {
  return (0, _statsd.trackApiResult)(false, event);
});
transport.on('failure', function (event) {
  return (0, _statsd.trackApiResult)(false, event);
});

if (__LOCAL_DEV__) {
  /* eslint-disable no-console */

  var logSuccess = function logSuccess(onServer, event) {
    if (event.params && (0, _keys2.default)(event.params).length) {
      console.info('%c[API' + (onServer ? ' (server)' : '') + '] %c' + event.method + '%c to %c' + event.name + ' (' + event.url + ')%c took %c' + event.duration + 'ms%c with %O', 'font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue', '', event.params);
    } else {
      console.info('%c[API' + (onServer ? ' (server)' : '') + '] %c' + event.method + '%c to %c' + event.name + ' (' + event.url + ')%c took %c' + event.duration + 'ms', 'font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue');
    }
  };

  var logFailure = function logFailure(onServer, event) {
    if (event.params && (0, _keys2.default)(event.params).length) {
      console.info('%c[API' + (onServer ? ' (server)' : '') + '] %cFAILURE ' + (event.code || event.httpStatus) + ' %c' + event.method + '%c to %c' + event.name + ' (' + event.url + ')%c took %c' + event.duration + 'ms%c with %O', 'font-weight: bold', 'color: red; font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue', '', event.params);
    } else {
      console.info('%c[API' + (onServer ? ' (server)' : '') + '] %cFAILURE ' + (event.code || event.httpStatus) + ' %c' + event.method + '%c to %c' + event.name + ' (' + event.url + ')%c took %c' + event.duration + 'ms', 'font-weight: bold', 'color: red; font-weight: bold', 'color:purple', '', 'color:green', '', 'color:blue');
    }
  };

  var requestLogNode = document.getElementById('api-requests');
  if (requestLogNode) {
    var apiRequestsMadeOnServer = JSON.parse(requestLogNode.textContent);
    apiRequestsMadeOnServer.forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          type = _ref2[0],
          event = _ref2[1];

      if (type === 'success') {
        logSuccess(true, event);
      } else {
        logFailure(true, event);
      }
    });
  }

  transport.on('success', logSuccess.bind(undefined, false));
  transport.on('failure', logFailure.bind(undefined, false));

  /* eslint-enable no-console */
}

var client = new _dal2.default(transport, _publicEndpoints2.default);
client.setUnauthenticatedToken((0, _universalConfig2.default)().unauthenticatedToken);
client.setHeader('platform', (0, _universalConfig2.default)().platform);

if (__LOCAL_DEV__) {
  window._client = client; // eslint-disable-line no-underscore-dangle
}

var dest = document.getElementById('content');

var storeData = JSON.parse(document.getElementById('store').textContent);

var _createStore = (0, _create2.default)(_reactRouter.browserHistory, storeData),
    store = _createStore.store,
    history = _createStore.history;

(0, _store.setStore)(store);

if (!storeData.locale) {
  store.dispatch((0, _locale.setLocale)(_supportedLocales2.default[0]));
}

if (store.getState().user.token) {
  client.useToken(store.getState().user.token);
}

if (storeData.entities.userProfile.data.default) {
  (0, _multitrack.setUserId)(storeData.entities.userProfile.data.default.id);
}
(0, _multitrack.setDeviceType)((0, _isMobile.isMobileDevice)() ? 'phone' : 'desktop');

var createElement = function createElement(Component, componentProps) {
  [].concat(Component.sagas || []).forEach(function (saga) {
    return store.runSaga(saga, client);
  });
  return _react2.default.createElement(Component, componentProps);
};

var routerLocation = history.createLocation(window.location.pathname + window.location.search);

var currentLocation = void 0;

history.listen(function historyListener(location) {
  if (window.ga) {
    window.ga('set', 'page', location.pathname);
  }
  store.dispatch((0, _request.setRequestDetailsOnClient)());

  var prevUrl = currentLocation ? currentLocation.pathname + currentLocation.search : null;
  var currentUrl = location.pathname + location.search;

  if (prevUrl !== currentUrl) {
    var event = document.createEvent('Event');
    event.previousUrl = currentLocation ? currentLocation.pathname : null;
    event.currentUrl = location.pathname;
    event.initEvent('historyChanged', true, true);
    document.body.dispatchEvent(event);
  }

  currentLocation = location;
  return historyListener;
}(routerLocation));

var onReactRouterError = function onReactRouterError(error) {
  console.error('React Router onError', error); // eslint-disable-line no-console
  if (window.Rollbar) {
    window.Rollbar.error(error);
  }
};

var _ref3 = window._locale || {},
    localeCode = _ref3.code,
    messages = _ref3.messages,
    formatData = _ref3.formatData; // eslint-disable-line no-underscore-dangle

(0, _reactIntl.addLocaleData)(formatData);

client.setHeader('Accept-Language', localeCode || _supportedLocales2.default[0]);

(0, _reactRouter.match)({
  routes: (0, _routes2.default)(store, client),
  location: routerLocation,
  history: history
}, function (err, redirectLocation, renderProps) {
  if (err) {
    onReactRouterError(err);
  }

  // DANGER WILL ROBINSON: history= must come AFTER renderProps
  // so it clobbers renderProps.history
  var component = _react2.default.createElement(_reactRouter.Router, (0, _extends3.default)({}, renderProps, {
    createElement: createElement,
    onError: onReactRouterError,
    history: history
  }));

  _reactDom2.default.render(_react2.default.createElement(
    _reactIntl.IntlProvider,
    { defaultLocale: 'en-US', locale: localeCode || 'en-US', messages: messages },
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store, key: 'provider' },
      _react2.default.createElement(
        _ClientProvider.ClientProvider,
        { client: client },
        component
      )
    )
  ), dest);

  if (process.env.NODE_ENV !== 'production') {
    window.React = _react2.default; // enable debugger
  }

  if (__DEVTOOLS__ && !window.devToolsExtension) {
    var DevTools = require('containers/DevTools/DevTools').DevTools;

    _reactDom2.default.render(_react2.default.createElement(
      _reactIntl.IntlProvider,
      { defaultLocale: 'en-US', locale: localeCode || 'en-US', messages: messages },
      _react2.default.createElement(
        _reactRedux.Provider,
        { store: store, key: 'provider' },
        _react2.default.createElement(
          _ClientProvider.ClientProvider,
          { client: client },
          _react2.default.createElement(
            _react.Fragment,
            null,
            component,
            _react2.default.createElement(DevTools, null)
          )
        )
      )
    ), dest);
  }
});